import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeProvider from './utils/ThemeContext';
import App from './App';
// import ErrorBoundary from './ErrorBoundary';
// import * as Sentry from "@sentry/react";
import { API_URL } from './config';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

// Global interceptor: automatically attach Authorization Bearer token to all Axios calls
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken');
  if (token && !config.headers.Authorization && !config.headers.authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

if (
  window.location.hostname === 'crm.dita.md' &&
  window.location.protocol !== 'https:' &&
  window.location.port !== '5173'
) {
  window.location.replace(`https://crm.dita.md:5173${window.location.pathname}`);
}


window.onerror = function (message, source, lineno, colno, error) {


  //console.log("Window error:", error);

  let userId = 'unknown';
  const token = localStorage.getItem('jwtToken');

  if (token) {
    try {
      // Using jwt-decode to properly decode the token
      const decoded = jwtDecode(token);
      userId = decoded?.userId || 'unknown';
    } catch (e) {
      console.error('Error decoding token:', e);
    }
  }

  fetch(`${API_URL}/api/send-error`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      error: error?.toString() || message,
      stack: error?.stack || `at ${source}:${lineno}:${colno}`,
      componentStack: `global | UserID: ${userId}`,
    }),
  });
};

window.onunhandledrejection = function (event) {
  //console.log("Unhandled rejection:", event.reason);
  let userId = 'unknown';
  const token = localStorage.getItem('jwtToken');

  if (token) {
    try {
      // Using jwt-decode to properly decode the token
      const decoded = jwtDecode(token);
      userId = decoded?.userId || 'unknown';
    } catch (e) {
      console.error('Error decoding token:', e);
    }
  }
  fetch(`${API_URL}/api/send-error`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      error: event.reason?.toString(),
      stack: event.reason?.stack,
      componentStack: `unhandledrejection | UserID: ${userId}`,
    }),
  });
};

// Verifică dacă URL-ul curent e HTTP
// Redirect forțat în browser


ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <Router>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Router>
  // </React.StrictMode>
);
